module.exports = __webpack_public_path__ + "img/avatar6.70c8701f.png";